import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { DownloadIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WarningNotice = ({
  count,
  alteredArticlesListLink
}) => /*#__PURE__*/_jsxs(View, {
  marginBlockStart: "1000",
  as: "div",
  children: [/*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importArticles.panel.importCompleted.alteredArticlesMessage",
      options: {
        count
      }
    })
  }), /*#__PURE__*/_jsx(View, {
    marginBlockStart: "100",
    as: "div",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importArticles.panel.importCompleted.alteredArticlesDescription"
    })
  }), /*#__PURE__*/_jsx(Link, {
    paddingBlockStart: "500",
    href: alteredArticlesListLink.url,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "knowledgeContentUI.importArticles.panel.importCompleted.alteredArticlesDownloadLink",
      options: {
        icon: /*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(DownloadIcon, {
            color: "icon-core-subtle"
          })
        })
      }
    })
  })]
});
WarningNotice.propTypes = {
  count: PropTypes.number.isRequired,
  alteredArticlesListLink: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};
export default WarningNotice;